"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const WarningNotificationWrapper = styled_components_1.default.div(({ theme, theme: { fontSizes, media, space, colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: colors.warning,
    alignItems: 'center',
    padding: `${space[2]} 20px`,
    color: colors.white,
    [media.tablet]: {
        paddingTop: '12px',
        paddingBottom: '12px',
    },
    '.warning-notification-title': {
        fontSize: fontSizes[2],
        fontWeight: 'bold',
        [media.tablet]: {
            fontSize: fontSizes[4],
        },
    },
    '.warning-notification-button': {
        backgroundColor: 'transparent',
        padding: 0,
    },
    '.warning-notification-icon': Object.assign(Object.assign({}, theme.icons.md), { [media.tablet]: Object.assign({}, theme.icons.xlg) }),
}));
const WarningNotificationBody = styled_components_1.default.div.attrs({
    className: 'notification-body',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    px: '20px',
    py: ['12px', 3],
    backgroundColor: 'bgWarning',
    fontSize: [2, 3],
}));
const WarningNotification = props => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const { title = t('importantNote.heading'), text, testId = 'warningNotification', className, } = props;
    return (react_1.default.createElement("div", { className: className, "data-id": testId },
        react_1.default.createElement(WarningNotificationWrapper, { className: "notification-heading" },
            title && (react_1.default.createElement("span", { className: "warning-notification-title", "data-id": `${testId}Title`, dangerouslySetInnerHTML: { __html: title } })),
            props.onClose ? (react_1.default.createElement(components_common_buttons_1.Button, { className: "warning-notification-button", icon: { name: 'close', size: 'lg' }, onClick: props.onClose })) : (react_1.default.createElement(components_common_icon_1.Icon, { name: 'warning', className: "warning-notification-icon" }))),
        react_1.default.createElement(WarningNotificationBody, { "data-id": `${testId}Text`, dangerouslySetInnerHTML: { __html: text } })));
};
exports.default = WarningNotification;
//# sourceMappingURL=WarningNotification.js.map